export class LoginUser {
  username: string;
  password: string;
  rememberMeFlag: boolean = true;

  constructor(username: string = '', password: string = '') {
    this.username = username;
    this.password = password;
  }
}
